<template>
  <div class="admin">
    <header class="admin-head">
      <h1 class="admin-title">Duallo admin</h1>
      <p class="admin-sub">Duallo staff tools — organizations, the scan pipeline, AI models and review requests.</p>
    </header>

    <div class="tabbar" role="tablist">
      <button v-for="t in tabs" :key="t.id" type="button" class="tab" :class="{ active: tab === t.id }"
        role="tab" @click="tab = t.id">{{ t.title }}</button>
    </div>

    <div class="tab-body">
      <OrganizationsTable v-if="tab === 'organizations'" />
      <ScanPipelineManagementPanel v-else-if="tab === 'scans'" />
      <AiProjectManagementTable v-else-if="tab === 'ai-models'" />
      <ModelGenConfigPanel v-else-if="tab === 'model-gen'" />
      <ScanReviewRequestsTable v-else-if="tab === 'review-requests'" />
    </div>
  </div>
</template>

<script>
import OrganizationsTable from '@/components/tables/OrganizationsTable.vue';
import ScanPipelineManagementPanel from '@/components/ScanPipelineManagementPanel.vue';
import AiProjectManagementTable from '@/components/tables/AiProjectManagementTable.vue';
import ModelGenConfigPanel from '@/components/ModelGenConfigPanel.vue';
import ScanReviewRequestsTable from '@/components/tables/ScanReviewRequestsTable.vue';

export default {
  name: 'DualloAdminView',
  components: {
    OrganizationsTable,
    ScanPipelineManagementPanel,
    AiProjectManagementTable,
    ModelGenConfigPanel,
    ScanReviewRequestsTable,
  },
  data() {
    return {
      tab: 'organizations',
      tabs: [
        { id: 'organizations', title: 'Organizations' },
        { id: 'scans', title: 'Manage scans' },
        { id: 'ai-models', title: 'AI projects' },
        { id: 'model-gen', title: 'Model generation' },
        { id: 'review-requests', title: 'Review requests' },
      ],
    };
  },
  mounted() {
    // Deep-link support: /duallo-admin?tab=<id> (also accepts the legacy ?menu=<id>).
    const requested = this.$route?.query?.tab || this.$route?.query?.menu;
    if (requested && this.tabs.some(t => t.id === String(requested))) {
      this.tab = String(requested);
    }
  },
};
</script>

<style scoped>
.admin {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  user-select: none;
}

.admin-head { margin-bottom: 18px; }
.admin-title { font-size: clamp(1.5rem, calc(12px + 1vw), 1.9rem); font-weight: 800; color: #fff; margin: 0; }
.admin-sub { margin: 6px 0 0; font-size: 0.92rem; color: #8aa0aa; }

.tabbar {
  display: flex; gap: 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  margin-bottom: 22px;
  overflow-x: auto;
  scrollbar-width: none;
}
.tabbar::-webkit-scrollbar { display: none; }
.tab {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 10px 4px; margin: 0 12px -1px 0;
  background: none; border: none; border-bottom: 2px solid transparent;
  color: #8aa0aa; font: inherit; font-size: 0.92rem; font-weight: 600; cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s ease, border-color 0.15s ease;
}
.tab:hover:not(.active) { color: #cfd8dc; }
.tab.active { color: #fff; border-bottom-color: var(--duallo-accent); }

.tab-body { flex: 1 1 auto; min-width: 0; min-height: 0; }
</style>
